"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
exports.errorHandler = errorHandler;
var _Actions = require("./Actions");
var apiActions = _interopRequireWildcard(require("../Actions"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  visibilityMap: {},
  visibilityMapCount: {},
  backgroundWorkMap: {},
  error: null,
  message: null
};
function errorHandler(state, action) {
  switch (action.type) {
    case apiActions.NETWORK_ERROR:
    case apiActions.REQUEST_ERROR:
    case _Actions.CUSTOM_ERROR:
    case _Actions.CONFIGURATION_NOT_FOUND_ERROR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          error: _objectSpread(_objectSpread({}, action.error), {}, {
            type: action.type,
            source: action.source
          })
        });
      }
    case _Actions.DISMISS_ERROR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          error: null
        });
      }
    default:
      return state;
  }
}
var UIReducer = function UIReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case _Actions.SET_VISIBLE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          visibilityMap: _objectSpread(_objectSpread({}, state.visibilityMap), {}, _defineProperty({}, action.name, action.show))
        });
      }
    case _Actions.SET_VISIBLE_WITH_COUNTER:
      {
        var stackCount = Math.max((state.visibilityMapCount[action.name] || 0) + (action.show ? 1 : -1), 0);
        return _objectSpread(_objectSpread({}, state), {}, {
          visibilityMap: _objectSpread(_objectSpread({}, state.visibilityMap), {}, _defineProperty({}, action.name, stackCount > 0)),
          visibilityMapCount: _objectSpread(_objectSpread({}, state.visibilityMapCount), {}, _defineProperty({}, action.name, stackCount))
        });
      }
    case _Actions.SET_WORK_IN_PROGRESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          backgroundWorkMap: _objectSpread(_objectSpread({}, state.backgroundWorkMap), {}, _defineProperty({}, action.name, action.value))
        });
      }
    case _Actions.SHOW_ALERT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          message: action.message
        });
      }
    case _Actions.DISMISS_ALERT:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          message: null
        });
      }
    default:
      return errorHandler(state, action);
  }
};
var _default = exports["default"] = UIReducer;